export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9756.9ff857c8.jpg";